import * as React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import NumberFormat from 'react-number-format';
import { TEXT } from 'texts';
import { TextFieldProps } from '@material-ui/core/TextField';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { useStyles } from './CardExpiryInput.styles';
import { useTranslation } from 'react-i18next';
import EditIcon from '@material-ui/icons/Edit';

type CardExpiryInputProps = {} & TextFieldProps;

const limit = (val: string, max: string) => {
  if (val.length === 1 && val[0] > max[0]) {
    val = '0' + val;
  }

  if (val.length === 2) {
    if (Number(val) === 0) {
      val = '01';

      //this can happen when user paste number
    } else if (val > max) {
      val = max;
    }
  }

  return val;
};

const cardExpiry = (val: string) => {
  let month = limit(val.substring(0, 2), '12');
  let year = val.substring(2, 4);
  if (val.length === 6) {
    //when paste from google pay
    year = val.substring(val.length - 2, val.length);
  }

  return month + (year.length ? '/' + year : '');
};

const NumberFormatCustom = (props: { inputRef?: (el: HTMLInputElement) => void; onChange?(value: unknown): void }) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef && inputRef}
      onValueChange={(values) => {
        onChange &&
          onChange({
            currentTarget: {
              value: values.value,
            },
          });
      }}
      format={cardExpiry}
      mask={['m', 'm', 'y', 'y']}
    />
  );
};
const CardExpiryInput: React.FC<CardExpiryInputProps> = ({disabled}) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const { formStore } = useStores();

  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    formStore.expireDate.setValue(event.currentTarget.value);
  };

  const handleBlur = () => {
    formStore.expireDate.validate();
  };

  const renderHelperText = () => {
    if (formStore.expireDate.error) {
      return t(formStore.expireDate.error);
    }
    return ' ';
  };

  const handleEditCardTerm = () => {
    formStore.expireDate.setValue('');
    (inputRef?.current as HTMLInputElement).focus();
  };

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="credit-expires">{t(TEXT.expireDate)}</InputLabel>
      <Input
        inputRef={inputRef}
        id="credit-expires"
        name="credit-expires"
        placeholder={t(TEXT.expirePlaceholder)}
        value={formStore.expireDate.value}
        onChange={handleChange}
        onBlur={handleBlur}
        type="tel"
        inputMode="numeric"
        inputComponent={NumberFormatCustom}
        disabled={disabled}
        onClick={(event) => {
          window.setTimeout(function () {
            (event.target as HTMLInputElement).focus();
          }, 0);
        }}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              onClick={handleEditCardTerm}
            >
              <EditIcon fontSize="small"/>
            </IconButton>
          </InputAdornment>
        }
      />
      <FormHelperText id="credit-expires-helper" className={styles.helper} error={!!formStore.expireDate.error}>
        {renderHelperText()}
      </FormHelperText>
    </FormControl>
  );
};

export default observer(CardExpiryInput);
